export default {
  pinnable: false,
  skipInQuickEditPanel: true,
  selectedBeforeDescendants: true,
};
